import React from "react";
import AppStoreLink from "./AppStoreLink";
import PlayStoreLink from "./PlayStoreLink";

const AppDownloadsLinks: React.FC = () => {

  return (
    <div className='flex justify-center py-2.5 md:py-5 overflow-hidden'>
      <AppStoreLink />
      <PlayStoreLink />
    </div>
  );
};

export default AppDownloadsLinks;
